import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { SET_APP_DATA } from '../../state/actions/app/index.tsx';
import {
	cardClearRelativeCard,
	cardEmptySelection,
	cardMultiSelect,
} from '../../state/actions/cards/selection/index.tsx';
import {
	getCards,
	getListSelectionRelativeCard,
	getSelectedCards,
} from '../../state/selectors/cards/index.tsx';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types.tsx';

export const postLoadCleanDataEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	// @ts-expect-error - TS2345: Types of property 'type' are incompatible. Type 'state.actions.cards.selection.CARD_MULTI_SELECT' is not assignable to type 'state.actions.cards.selection.CARD_EMPTY_SELECTION'.
	action$.ofType(SET_APP_DATA).flatMap(() => {
		const state = store.getState();
		const actions = [];

		// remove deleted issues from the list
		const cardIds = Object.keys(getCards(state)).map((id) => Number(id));
		const selectedCards = getSelectedCards(state);
		if (selectedCards.length === 0) {
			return Observable.empty<never>();
		}

		const existingSelectedCards = selectedCards.filter((cardId) => cardIds.includes(cardId));
		const relativeCard = getListSelectionRelativeCard(state);

		if (existingSelectedCards.length !== selectedCards.length) {
			if (existingSelectedCards.length === 0) {
				return Observable.of(cardEmptySelection());
			}
			actions.push(cardMultiSelect(existingSelectedCards));
		}

		if (
			relativeCard &&
			existingSelectedCards.length > 0 &&
			!existingSelectedCards.includes(relativeCard)
		) {
			actions.push(cardClearRelativeCard());
		}

		return Observable.from(actions);
	});
